import { useLogin } from "@refinedev/core";
import { useEffect, useRef } from "react";

import { ThemedTitleV2 } from "@refinedev/antd";
import { Layout, Space, Typography } from "antd";

import { CredentialResponse } from "../interfaces/google";

import { AppIcon } from "components/app-icon";
import { config } from "config";

// Todo: Update your Google Client ID here
const GOOGLE_CLIENT_ID = config.ACCESSGOOGLE
  // "1041339102270-e1fpe2b6v6u1didfndh7jkjmpcashs4f.apps.googleusercontent.com";
  // "599740533547-fuugot3fl1h9s5qjntpb9i5l2tac3ohv.apps.googleusercontent.com";

  // PARA QUE ESTO FUNCIONE, DEBE TENERSE UNA LLAVE DEL CLIENTE DE GOOGLE 
  // EN MI CASO INGRESO A:
  // https://console.cloud.google.com/apis/credentials?project=autenticacion-251920
  // LA APP ES AUTENTICACIÓN Y EL ID de clientes OAuth 2.0 ES INgreso Virtualpro.co
  // SE USAN 2 LLAVES, UNA PARA DESARROLLO QUE CONFIGURA REFINE 
  // Y OTRA PARA PRODUCCIÓN QUE ES LA DE VIRTUALPRO, ESTO PORQUE YA SE TIENE ESTA CONFIGURACIÓN Y FUNCIONA,
  // POR ESO SE MONTO ALLÍ. O SE PODRIA CREAR UNA AUTENTICACIÓN PROPIA

export const Login: React.FC = () => {
  const { mutate: login } = useLogin<CredentialResponse>();

  const GoogleButton = (): JSX.Element => {
    const divRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
      if (typeof window === "undefined" || !window.google || !divRef.current) {
        return;
      }

      try {
        window.google.accounts.id.initialize({
          ux_mode: "popup",
          client_id: GOOGLE_CLIENT_ID,
          callback: async (res: CredentialResponse) => {
            if (res.credential) {
              login(res);
            }
          },
        });
        window.google.accounts.id.renderButton(divRef.current, {
          theme: "filled_blue",
          size: "medium",
          type: "standard",
        });
      } catch (error) {
        console.log(error);
      }
    }, []);

    return <div ref={divRef} />;
  };

  return (
    <Layout
      style={{
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Space direction="vertical" align="center">
        <ThemedTitleV2
          collapsed={false}
          wrapperStyles={{
            fontSize: "22px",
            marginBottom: "36px",
          }}
          text="Verbo8"
          icon={<AppIcon />}
        />
        <GoogleButton />
        <Typography.Text type="secondary">
          Powered by
          <img
            style={{ padding: "0 5px" }}
            alt="Google"
            src="https://refine.ams3.cdn.digitaloceanspaces.com/superplate-auth-icons%2Fgoogle.svg"
          />
          Google
        </Typography.Text>
      </Space>
    </Layout>
  );
};
